// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconGrapes = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path
      fillRule="evenodd"
      d="M15 3H9v2h2v2.702a4 4 0 10-2.615 7.418 4 4 0 107.23 0A4.001 4.001 0 1013 7.702V5h2zM9 13.167a2 2 0 100-4 2 2 0 000 4m4-2a2 2 0 104 0 2 2 0 00-4 0m-1 7.666a2 2 0 100-4 2 2 0 000 4"
    />
  );
export default SvgIconGrapes;
